import { FunctionComponent } from 'react';

import SectionFilters from 'components/modules/public/layout/jobs/CityFilters';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageOffersSectionFilters: FunctionComponent<Props> = ({
    title,
    cities,
    searchParams,
    onChangeSearchParam,

}) => {
    return (
        <StyledComponent
            className="public-page-offers-section-filters"
        >
            <SectionFilters
                title={title}
                cities={cities}
                searchParams={searchParams}
                onChangeSearchParam={onChangeSearchParam}
            />
        </StyledComponent>
    );
};

export default PublicPageOffersSectionFilters;